<template>
  <entity-list-table
    :title="title"
    :data-service="dataService"
    :headers="headers"
    :create-route-name="createRouteName"
    :edit-route-name="editRouteName"
    :allow-delete="true"
    :show-status-column="false"
    :edit-permission="editPermission"
  >
    <!-- eslint-disable-next-line -->
    <template #item.inn="{ item }">
      {{ item.inn }}<span v-if="item.kpp"> / {{ item.kpp }}</span>
    </template>

    <!-- eslint-disable-next-line -->
    <template #item.isDefault="{ item }">
      <v-chip
        v-if="item.isDefault"
        color="green"
        small
        dark
      >
        По-умолчанию
      </v-chip>
      <span v-else>—</span>
    </template>
  </entity-list-table>
</template>

<script>
  import EntityListTable from '@/components/ui/crud/EntityListTable.vue'
  import FaktLegalEntityDataService from '@/services/api/FaktLegalEntityDataService'
  import RouteName from '@/models/enums/RouteName'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'

  export default {
    name: 'FaktLegalEntityList',
    components: { EntityListTable },
    data () {
      return {
        title: 'Юрлица FAKT',
        dataService: FaktLegalEntityDataService,
        createRouteName: RouteName.AdministrationFaktLegalEntityCreate,
        editRouteName: RouteName.AdministrationFaktLegalEntityEdit,
        editPermission: CRMPermission.BillingFaktLegalEntitiesManage,

        headers: [
          { text: 'ID', value: 'id', align: 'start' },
          { text: 'Сокращённое имя', value: 'shortName', align: 'start' },
          { text: 'Название', value: 'name', align: 'start' },
          { text: 'ИНН / КПП', value: 'inn', align: 'start', sortable: false },
          { text: 'Банк', value: 'bankName', align: 'start', sortable: false },
          { text: 'ЮKassa shop_id', value: 'yookassaShopId', align: 'center', sortable: false },
          { text: 'По-умолчанию', value: 'isDefault', align: 'center', sortable: false },
          { text: 'Аккаунтов', value: 'paymentAccountsCount', align: 'center' },
        ],
      }
    },
  }
</script>
